import React, { useContext, useMemo, useState } from 'react';
import "./workshops.css";
import Page from '../../Utilities/Page';
import Card from '../../Utilities/Card';
import FilterBar from '../../Utilities/FilterBar';
import DataContext from '../../../DataContext';

const Workshops = () => {
  const { workshops } = useContext(DataContext);
  const [search, setSearch] = useState("");
  const [type, setType] = useState("");

  const types = useMemo(() => {
    const found = (workshops || []).map(workshop => workshop.data && workshop.data.type).filter(Boolean);

    return [...new Set(found)].sort((a, b) => a.localeCompare(b));
  }, [workshops]);

  const shown = useMemo(() => {
    const term = search.trim().toLowerCase();

    return (workshops || []).filter(workshop => {
      const record = workshop.data || {};
      const haystack = `${record.title || ""} ${record.description || ""}`.toLowerCase();

      if (term !== "" && !haystack.includes(term)) return false;
      if (type !== "" && record.type !== type) return false;

      return true;
    });
  }, [workshops, search, type]);

  /* the shell stays mounted while the records load, so the navigation bar
     and the footer never disappear between routes */
  const loading = !workshops || workshops.length === 0;

  return (
    <Page cls='workshops fcs' title='Chai Cheng Xun | Workshops'>
      <div className="page-wrap">
        <div className="cmd"><span className="prompt">$</span> cat ~/workshops</div>
        <div className="d-title">Workshops</div>
        <div className="d-text intro">
          Sessions I have run for students and communities, each one with the materials I wrote for it.
        </div>
        {loading ? (
          <div className="d-text loading">Loading...</div>
        ) : (
        <>
        <FilterBar
          placeholder='Search workshops...'
          search={search}
          setSearch={setSearch}
          filters={[
            { label: "All Types", options: types, value: type, onChange: setType }
          ]}
          shown={shown.length}
          total={(workshops || []).length}
        />
        <div className="card-grid">
          {
            shown.map((workshop) => {
              const record = workshop.data || {};

              return (
                <Card
                  key={workshop.id}
                  layout='stack'
                  to={record.link || ""}
                  title={record.title}
                  meta={record.type ? `Type: ${record.type}` : null}
                  description={record.description}
                  action='materials'
                />
              );
            })
          }
          {shown.length === 0 && <div className="empty card static d-text">Nothing matches those filters.</div>}
        </div>
        </>
        )}
      </div>
    </Page>
  );
};

export default Workshops;
